import { FaUser } from "react-icons/fa6";
import { Section } from "../../types/section";

export type ExamHeaderProps = {
    driver: {
        name: string;
        licenseNumber: string;
    };
    examType: {
        name: string;
    };
    sections: Section[];
};

export function ExamHeader({ driver, examType, sections }: ExamHeaderProps) {
    function calculateExamProgressPercentage() {
        const totalQuestions = sections.reduce((acc, section) => {
            return acc + section.questions.length;
        }, 0);

        const answeredQuestions = sections.reduce((acc, section) => {
            return acc + section.questions.filter((q) => q.answer).length;
        }, 0);

        return Math.round((answeredQuestions / totalQuestions) * 100);
    }

    return (
        <div className="p-3 border-b border-base-300 bg-gray-50">
            <div className="flex justify-between items-center">
                <div>
                    <h2 className="text-lg font-bold">{examType.name}</h2>
                    <div className="flex items-center text-xs text-gray-600 mt-0.5">
                        <FaUser className="w-3 h-3 mr-1" />
                        <span>{driver.name}</span>
                        <span className="mx-1">•</span>
                        <span>{driver.licenseNumber}</span>
                    </div>
                </div>
                <div className="text-right">
                    <div className="text-xs text-gray-600 mb-1">
                        Progress: {calculateExamProgressPercentage()}%
                    </div>
                    <div className="w-36 h-1.5 bg-gray-200 rounded-full overflow-hidden">
                        <div
                            className="h-full bg-green-500 rounded-full"
                            style={{
                                width: `${calculateExamProgressPercentage()}%`,
                            }}
                        ></div>
                    </div>
                </div>
            </div>
        </div>
    );
}
